"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HOME_EQUITY_CARD_BUNDLE_DEPOSIT_PRODUCT_NAMES = exports.HOME_EQUITY_CARD_PRODUCT_NAME = exports.REWARDS_CARD_PRODUCT_NAME = void 0;
exports.getDepositProductNames = getDepositProductNames;
exports.isDefaultYieldOffer = isDefaultYieldOffer;
const asset_1 = require("../origination/asset");
const onboarding_1 = require("./onboarding");
exports.REWARDS_CARD_PRODUCT_NAME = 'Aven Rewards Card';
exports.HOME_EQUITY_CARD_PRODUCT_NAME = 'Aven Home Equity Card';
const MISSING_SOURCE_DEPOSIT_PRODUCT_NAMES = {
    depositProductName: 'Aven Checking',
    shortDepositProductName: 'Aven Checking',
};
const DEPOSIT_PRODUCT_NAMES_BY_SOURCE = {
    [onboarding_1.DepositOnboardingSource.DEFAULT]: {
        depositProductName: 'Aven High-Yield Checking',
        shortDepositProductName: 'High-Yield Checking',
    },
    [onboarding_1.DepositOnboardingSource.CASHBACK_BOOST_DEPOSIT_BUNDLE]: {
        depositProductName: 'Aven Rewards Checking',
        shortDepositProductName: 'Rewards Checking',
    },
    [onboarding_1.DepositOnboardingSource.FOREST_RIVER]: {
        depositProductName: 'Forest River Trailhead Deposit',
        shortDepositProductName: 'Trailhead Deposit',
    },
    [onboarding_1.DepositOnboardingSource.APR_DISCOUNT_DEPOSIT_BUNDLE_HIGH_YIELD_CHECKING]: {
        depositProductName: 'Aven High-Yield Checking',
        shortDepositProductName: 'High-Yield Checking',
    },
};
exports.HOME_EQUITY_CARD_BUNDLE_DEPOSIT_PRODUCT_NAMES = {
    depositProductName: 'Aven Select Checking',
    shortDepositProductName: 'Select Checking',
};
/** TODO: remove the Home HELOC branch once Rewards Checking is renamed to Select Checking. */
function getDepositProductNames(source, sourceLoanAssetType) {
    if (source == null) {
        return MISSING_SOURCE_DEPOSIT_PRODUCT_NAMES;
    }
    if (source === onboarding_1.DepositOnboardingSource.CASHBACK_BOOST_DEPOSIT_BUNDLE && sourceLoanAssetType != null) {
        const homeAssetTypes = asset_1.ASSET_TYPE_GROUP_KEY_TO_ASSET_TYPES[asset_1.AssetTypeGroupKey.home];
        if (homeAssetTypes.includes(sourceLoanAssetType)) {
            return exports.HOME_EQUITY_CARD_BUNDLE_DEPOSIT_PRODUCT_NAMES;
        }
    }
    return DEPOSIT_PRODUCT_NAMES_BY_SOURCE[source];
}
function isDefaultYieldOffer(source, depositApyPercentage) {
    return source === onboarding_1.DepositOnboardingSource.DEFAULT && depositApyPercentage > 0;
}
